import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
const SECTION_HEADING = 'Detailed Review';
export default function DetailedReview() {
  const $ = _c(4);
  const {
    detailedReview
  } = useReviewContext();
  if (!detailedReview) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionTitle icon={{
      iconNode: <span aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-manage-search" style={{
        width: "2rem",
        height: "2rem",
        backgroundColor: "#008254"
      }} />
    }} heading={{
      text: SECTION_HEADING
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      md: 5
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== detailedReview) {
    t2 = <Grid size={12} id={tableOfContentsMap.DETAILED_REVIEW.id}><FeatureViewed entityName="accordion" entitySection={SECTION_HEADING} impressionPosition={2}><Box>{t0}<Box ml={t1}><StructuredContentRenderer doc={detailedReview} /></Box></Box></FeatureViewed></Grid>;
    $[2] = detailedReview;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}